import { api } from '../lib/axios';

interface GetChunkingByHeadingPreviewBody {
  fileUrl: string;
  headingLevel: number;
}

interface GetChunkingByHeadingPreviewResponse {
  totalChunks: number;
  chunksPreview: Array<string>;
}

async function getChunkingByHeadingPreview(
  body: GetChunkingByHeadingPreviewBody,
) {
  const response = await api.post<GetChunkingByHeadingPreviewResponse>(
    'vector/check-headings',
    body,
  );

  return response.data;
}

export {
  getChunkingByHeadingPreview,
  type GetChunkingByHeadingPreviewBody,
  type GetChunkingByHeadingPreviewResponse,
};
